$(document).on('turbolinks:load', function() {
    console.log("vlad");

    lightbox.option({
        'resizeDuration': 200,
        'wrapAround': false,
        'alwaysShowNavOnTouchDevices': true,
    });

});